<div class="panel panel-default" (window:resize)="onResize($event)">
  <div class="panel-title">Monthly Commission Generated </div>
  <div class='chart-container'>
    <np-ngx-charts-area-chart [scheme]="colorScheme" [schemeLine]="colorSchemeLine" [schemeCircle]="colorSchemeCircle" [showYAxisLabel]="true"
      [results]="multi" [gradient]="gradient" [yAxis]="showYAxis" [xAxis]="showXAxis" [showGridLines]="showGridLines" (select)="showDialog($event)">

      <ng-template #tooltipTemplate let-model="model">
        <div class="nightfall">
          <div>{{model.name}}: {{model.value}}</div>
        </div>
      </ng-template>
    </np-ngx-charts-area-chart>

    <div class="d-block">
      <div class="text-center">
        <span class="round-box d-inline-block"></span>
        Hover over node to display detail</div>
    </div>
  </div>
</div>